'use client';
import {
  IMessagePayload,
  useMessageContext,
  useConversationContext,
  useToast,
} from '@ui/components';
import { sendGAEvent } from '@next/third-parties/google';
import { BasePostCreationForm } from './base-post-creation-form';

interface PostFormProps {
  creatorData?: { platform_settings?: { enable_video_uploads?: boolean } };
}

export const PostForm = ({ creatorData }: PostFormProps) => {
  const toast = useToast();
  const messageState = useMessageContext('creator');
  const conversationState = useConversationContext();

  const onSubmit = async (
    message: IMessagePayload,
    description: string,
    mentions: string[],
    clearEditorContent: () => void,
    clearMessage: () => void,
    discardFiles: () => void,
  ) => {
    try {
      const res = await messageState.onCreateMessage({
        message: {
          ...message,
          description,
          creator_id: conversationState.creator_id,
          thread_id: messageState.query.thread_id,
          user_id: conversationState.creator_id,
          mentions,
          created_by_creator: true,
        },
      });
      if (res?.data?.message?.id) {
        clearMessage();
        discardFiles();
        clearEditorContent();
        // Send GA Event for Successful Post
        sendGAEvent('event', 'CreatePostSuccessful', {
          event_label: 'Creator Post success',
          creatorId: conversationState.creator_id,
          postId: res?.data.message?.id,
        });
        // create post thread
        await messageState.onCreateMessageThread({
          message_id: res?.data?.message?.id,
          conversation_id: res?.data?.message_thread?.conversation_id,
          queryParams: messageState.query,
        });
      } else {
        toast({ title: 'Error creating post, please try again' }, { type: 'error' });
      }
    } catch (e) {
      toast({ title: 'Error creating post, please try again' }, { type: 'error' });

      // Send GA Event for failed Post
      sendGAEvent('event', 'CreatePostFailed', {
        creatorId: conversationState.creator_id,
        event_label: 'Creator Post Failed',
      });
    }
  };

  return (
    <BasePostCreationForm
      onSubmit={onSubmit}
      authorAvatarURL={conversationState.userAvatarURL}
      userType="creator"
      currentUser={messageState.isCreator ? 'creator' : 'fan'}
      isLoading={messageState.isCreating || messageState.isPostingImage}
      placeholder="Compose a post..."
      editorLabel="Share with your audience"
      buttonLabel="Post"
      enableSuggestions
      enableSendEmailToggle={true}
      showSaveDraftButton
      creatorData={creatorData}
    />
  );
};
